import React from 'react';

import SafetyCrossSection from 'components/modals/eventManagers/safetyCrossSection.component';
import ChartSectionsSection from 'components/modals/eventManagers/chartSectionsSection.component';
import GraphicUnitSection from 'components/modals/eventManagers/graphicUnitSection.component';
import { Option } from '@umanforge/common';
import type { GroupedOption } from '@common_components/inputs/selects/selectInput.component';
import type { ChartSection, ChartSectionListHandle } from 'components/inputs/chartSectionList.interfaces';
import { Theme } from 'interfaces/theme.interface';

interface EventManagerSafetyTabProps {
  createEventOnWarning: boolean;
  setCreateEventOnWarning: ( value: boolean ) => void;
  createEventOnError: boolean;
  setCreateEventOnError: ( value: boolean ) => void;
  safetyCrossThemeWarningId: string | null;
  setSafetyCrossThemeWarningId: ( value: string | null ) => void;
  safetyCrossThemeErrorId: string | null;
  setSafetyCrossThemeErrorId: ( value: string | null ) => void;
  chartSections: ChartSection[];
  setChartSections: ( sections: ChartSection[] ) => void;
  graphicUnitSuffix: string;
  setGraphicUnitSuffix: ( value: string ) => void;
  graphicUnits: string[];
  setGraphicUnits: ( updater: ( prev: string[] ) => string[] ) => void;
  chartUnitOptions: GroupedOption[];
  managerOptions: GroupedOption[];
  eventManagerThemes: Theme[];
  defaultChartSettingManagerId: string;
  defaultChartSettingUnitId: string | null;
  chartSectionListRef: React.Ref<ChartSectionListHandle>;
  onPendingChartSettingsChange: ( hasPending: boolean ) => void;
  eventManagerId: string;
}

const EventManagerSafetyTab: React.FC<EventManagerSafetyTabProps> = ( {
  createEventOnWarning,
  setCreateEventOnWarning,
  createEventOnError,
  setCreateEventOnError,
  safetyCrossThemeWarningId,
  setSafetyCrossThemeWarningId,
  safetyCrossThemeErrorId,
  setSafetyCrossThemeErrorId,
  chartSections,
  setChartSections,
  graphicUnitSuffix,
  setGraphicUnitSuffix,
  graphicUnits,
  setGraphicUnits,
  chartUnitOptions,
  managerOptions,
  eventManagerThemes,
  defaultChartSettingManagerId,
  defaultChartSettingUnitId,
  chartSectionListRef,
  onPendingChartSettingsChange,
  eventManagerId,
} ) => {
  const eventManagerThemesAsOptions: Option<Theme>[] = eventManagerThemes.map( theme => { return { value: theme.id, label: theme.name, object: theme, isDisabled: false, canDelete: false }; } );

  const allThemeOptions: GroupedOption[] = [ {
    options: eventManagerThemes.map( theme => { return { id: theme.id, label: theme.name }; } ),
  } ];

  return (
    <div className="flex flex-col gap-4">
      <SafetyCrossSection
        themesOption={ eventManagerThemesAsOptions }
        createEventOnWarning={ createEventOnWarning }
        setCreateEventOnWarning={ setCreateEventOnWarning }
        createEventOnError={ createEventOnError }
        setCreateEventOnError={ setCreateEventOnError }
        safetyCrossThemeWarningId={ safetyCrossThemeWarningId }
        setSafetyCrossThemeWarningId={ setSafetyCrossThemeWarningId }
        safetyCrossThemeErrorId={ safetyCrossThemeErrorId }
        setSafetyCrossThemeErrorId={ setSafetyCrossThemeErrorId }
      />
      <hr className="my-4" />
      <div>
        <ChartSectionsSection
          chartSections={ chartSections }
          setChartSections={ setChartSections }
          chartUnitOptions={ chartUnitOptions }
          managerOptions={ managerOptions }
          themeOptions={ allThemeOptions }
          defaultChartSettingManagerId={ defaultChartSettingManagerId }
          defaultChartSettingUnitId={ defaultChartSettingUnitId }
          chartSectionListRef={ chartSectionListRef }
          onPendingChartSettingsChange={ onPendingChartSettingsChange }
          eventManagerId={eventManagerId}
        />
      </div>
      <hr className="my-4" />
      <GraphicUnitSection
        graphicUnitSuffix={ graphicUnitSuffix }
        setGraphicUnitSuffix={ setGraphicUnitSuffix }
        graphicUnits={ graphicUnits }
        setGraphicUnits={ setGraphicUnits }
      />
    </div>
  );
};

export default EventManagerSafetyTab;
